import script from "./GroupControl.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupControl.vue?vue&type=script&setup=true&lang=ts"

import "./GroupControl.vue?vue&type=style&index=0&id=18ee8ea2&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18ee8ea2"]])

export default __exports__